module.exports = __webpack_public_path__ + "img/picto-telecharger.29263a28.svg";